import { Gift, Cake, Drumstick, Sparkles, Sun, Heart, Users } from "lucide-react";
import { useContent } from "../contexts/ContentContext";

const ICON_MAP = { Gift, Cake, Drumstick, Sparkles, Sun, Heart, Users };

export const Programs = () => {
  const { data: programs } = useContent("programs");
  if (!programs) return null;

  const items = programs.items || [];
  const stats = programs.impact_stats || [];

  return (
    <section id="programs" data-testid="programs-section" className="py-20 md:py-28 bg-slate-50 relative overflow-hidden">
      <div aria-hidden="true" className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-[#FFD100]/20 blur-3xl" />
      <div aria-hidden="true" className="absolute -bottom-24 -left-24 w-96 h-96 rounded-full bg-[#2563EB]/15 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex items-end justify-between flex-wrap gap-6">
          <div className="max-w-2xl">
            <span className="section-eyebrow">
              <Users className="w-3.5 h-3.5" />
              {programs.eyebrow}
            </span>
            <h2 data-testid="programs-heading" className="mt-5 font-display text-3xl md:text-5xl font-bold tracking-tight text-slate-900 leading-tight">
              {programs.heading_lead}
              <br />
              <span className="text-gradient-brand">{programs.heading_accent}</span>.
            </h2>
          </div>
          <p className="text-base text-slate-600 max-w-md">{programs.intro}</p>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((p, i) => {
            const Icon = ICON_MAP[p.icon] || Heart;
            return (
              <article
                key={i}
                data-testid={`program-card-${i}`}
                className="card-soft group p-7 md:p-8 relative overflow-hidden"
              >
                <span className="absolute top-5 right-6 font-display text-5xl font-extrabold text-slate-100 group-hover:text-[#2563EB]/15 transition-colors">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="w-14 h-14 rounded-2xl grid place-items-center bg-[#2563EB]/10 text-[#2563EB]">
                  <Icon className="w-7 h-7" strokeWidth={2.2} />
                </span>
                <p className="mt-5 text-[11px] uppercase tracking-[0.18em] font-bold text-slate-500">{p.tag}</p>
                <h3 className="mt-2 font-display text-xl md:text-2xl font-bold text-slate-900 leading-tight">{p.title}</h3>
                <p className="mt-3 text-sm md:text-base text-slate-600 leading-relaxed">{p.description}</p>
              </article>
            );
          })}
        </div>

        <div data-testid="programs-impact-banner" className="mt-14 rounded-[28px] bg-gradient-to-br from-[#1E3A8A] via-[#1D4ED8] to-[#2563EB] text-white p-8 md:p-12 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6 relative overflow-hidden">
          <div aria-hidden="true" className="absolute -top-16 -right-16 w-64 h-64 rounded-full bg-[#FFD100]/20 blur-3xl" />
          {stats.map((s, i) => (
            <div key={i} className="relative">
              <p className="font-display text-3xl md:text-4xl lg:text-5xl font-extrabold text-[#FFD100]">{s.value}</p>
              <p className="mt-2 text-xs md:text-sm uppercase tracking-[0.14em] font-semibold text-white/80">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
